// @ts-nocheck
import { WhatsApp } from "@material-ui/icons/";
import { Tooltip } from "@material-ui/core";
// material
import { useTheme } from "@material-ui/core/styles";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
// components
import "moment/locale/he"; // without this line, language is not imported
import { useEffect, useState } from "react";
import "typeface-roboto"; // Needed for the grid font
import Label from "../../Label";
// hooks
import { useWebotStatus } from "hooks/useWebotStatus";

export default function ChromeExtensionStatusSignal({ customColor = "#000000" }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  // Use the useWebotStatus hook instead of duplicating the logic
  const { appStatus, dataReady, errorData } = useWebotStatus();

  return (
    <Tooltip
      title={!dataReady ? "מתחבר לשרת" : appStatus ? "החיבור תקין" : errorData}
      enterTouchDelay={0}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Label
          variant="filled"
          color={!dataReady ? "warning" : appStatus ? "success" : "error"}
          sx={{
            height: "18px",
            transform: "translate(-8px,-4px)",
            minWidth: "0px",
            fontSize: "0.6rem",
            padding: "0 4px",
            position: "absolute",
            fontWeight: 900
          }}
        >
          {!dataReady ? "?" : appStatus ? "ON" : "OFF"}
        </Label>
        <WhatsApp color={customColor} sx={{ fontSize: "2rem" }} />
      </div>
    </Tooltip>
  );
}
